import React from 'react';
import Navbar from '../navbar';
import { Alert, Col, Row } from 'reactstrap';

class Expired extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={{ height: '100%', minHeight: '100%' }}>
        <Navbar hideLogout={true} />
        <div style={{ maxWidth: '90%', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center' }}>Links Expired</h2>
          <Row>
            <Col xs={4} />
            <Col xs={4}>
              <Alert color="info" style={{ textAlign: 'center' }}>
                Your authorization to view these documents has expired.
              </Alert>
            </Col>
            <Col xs={4} />
          </Row>
        </div>
      </div>
    );
  }
}

export default Expired;
